export default "__VITE_ASSET__2a0bd4ee__"